import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowCircularOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowCircularOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M4.5 12c0-2.45 1.18-4.61 3-5.98V10h2V3h-7v2h3.1c-1.9 1.74-3.1 4.23-3.1 7 0 4.9 3.73 8.94 8.5 9.45v-2.02C7.34 18.94 4.5 15.8 4.5 12ZM21.5 12c0-4.9-3.73-8.94-8.5-9.45v2.02c3.66.49 6.5 3.63 6.5 7.43 0 2.45-1.18 4.61-3 5.98V14h-2v7h7v-2h-3.1c1.9-1.74 3.1-4.23 3.1-7Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ArrowCircularOutlined;